module.exports = __webpack_public_path__ + "static/icon-increase-width@3x-5c94c48b237b9ec0e35cc7a020d833fe.png";